import { PermissionLevel } from "@follaw-fr/constants/enums/permission-level.enum";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";

type PermissionGuardParams = {
  permissionLevel?: PermissionLevel;
  action?: () => void;
  fallBack?: () => void;
};

export function usePermissionGuard() {
  const { hasPermission } = useUserSettingsStore();

  const permissionGuard = ({
    permissionLevel,
    action,
    fallBack,
  }: PermissionGuardParams) => {
    if (hasPermission(permissionLevel ?? PermissionLevel.SOCIETAL)) {
      return action?.();
    } else {
      return fallBack?.();
    }
  };

  return {
    permissionGuard,
  };
}
